import React from 'react';
import PropTypes from 'prop-types';

const Train = ({ fillWhite = '#fff', fillGreen = '#14AE5C', fillBlack = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={45} height={60} viewBox="0 0 45 60" fill="none" {...props}>
    <path
      fill={fillWhite}
      fillRule="evenodd"
      d="M41.664 15.934V15a5.006 5.006 0 0 0-5.01-5.005H11.813A5.005 5.005 0 0 0 6.808 15v34.97a5.005 5.005 0 0 0 5.005 5.005h24.84c2.77 0 5.011-2.241 5.011-5.006V36.923"
      clipRule="evenodd"
    />
    <path
      fill={fillGreen}
      fillRule="evenodd"
      d="M41.662 48.477H6.806v2.353a4.146 4.146 0 0 0 4.148 4.144h26.56a4.146 4.146 0 0 0 4.148-4.144v-2.353Z"
      clipRule="evenodd"
    />
    <path
      fill={fillBlack}
      d="M36.654 56H11.813a6.037 6.037 0 0 1-6.03-6.03V15a6.04 6.04 0 0 1 6.03-6.03h24.841c3.328 0 6.036 2.707 6.036 6.03v.933c0 .564-.462 1.026-1.026 1.026a1.029 1.029 0 0 1-1.025-1.026V15c0-2.195-1.79-3.98-3.985-3.98H11.813A3.983 3.983 0 0 0 7.833 15v34.97a3.983 3.983 0 0 0 3.98 3.979h24.841c2.2 0 3.985-1.785 3.985-3.98V36.923c0-.564.461-1.026 1.025-1.026.564 0 1.026.462 1.026 1.026V49.97c0 3.323-2.708 6.031-6.036 6.031Z"
    />
    <path
      fill={fillGreen}
      d="M29.167 7.523a1.029 1.029 0 0 1-1.025-1.026V1.026c0-.564.461-1.026 1.025-1.026.564 0 1.026.462 1.026 1.026v5.471c0 .565-.462 1.026-1.026 1.026ZM19.3 7.523a1.029 1.029 0 0 1-1.026-1.026V1.026C18.274.462 18.736 0 19.3 0c.564 0 1.026.462 1.026 1.026v5.471c0 .565-.462 1.026-1.026 1.026Z"
    />
    <path
      fill={fillBlack}
      d="M41.668 30.77a1.029 1.029 0 0 1-1.025-1.026V23.59c0-.564.461-1.026 1.025-1.026.564 0 1.026.462 1.026 1.026v6.154c0 .564-.462 1.025-1.026 1.025ZM36.73 43.508a1.029 1.029 0 0 1-1.025-1.026v-7.457c0-2.21-1.8-4.01-4.016-4.01H16.776c-2.21 0-4.01 1.8-4.01 4.01v7.457c0 .564-.461 1.026-1.025 1.026a1.029 1.029 0 0 1-1.026-1.026v-7.457a6.067 6.067 0 0 1 6.061-6.061H31.69c3.344 0 6.067 2.718 6.067 6.061v7.457c0 .564-.462 1.026-1.026 1.026ZM36.73 26.016a1.029 1.029 0 0 1-1.025-1.026v-4.959c0-2.21-1.8-4.01-4.016-4.01H16.776c-2.21 0-4.01 1.8-4.01 4.01v4.96c0 .563-.461 1.025-1.025 1.025a1.029 1.029 0 0 1-1.026-1.026v-4.959a6.067 6.067 0 0 1 6.061-6.061H31.69c3.344 0 6.067 2.718 6.067 6.061v4.96c0 .563-.462 1.025-1.026 1.025ZM41.668 49.503c-.323 0-32.333-.01-34.851 0a1.024 1.024 0 0 1-1.026-1.02c0-.565.456-1.026 1.02-1.032 2.524-.01 34.539 0 34.862 0 .564 0 1.026.462 1.026 1.026 0 .564-.462 1.026-1.026 1.026h-.005ZM31.668 2.051H16.807a1.029 1.029 0 0 1-1.026-1.025c0-.564.462-1.026 1.026-1.026h14.861c.565 0 1.026.462 1.026 1.026 0 .564-.462 1.025-1.026 1.025Z"
    />
    <path
      fill={fillBlack}
      fillRule="evenodd"
      d="M17.802 54.975h-3.497v2.25c0 .468.184.909.513 1.237a1.742 1.742 0 0 0 2.471 0c.328-.328.513-.77.513-1.236v-2.251Z"
      clipRule="evenodd"
    />
    <path
      fill={fillBlack}
      d="M16.054 60a2.755 2.755 0 0 1-1.96-.81 2.762 2.762 0 0 1-.815-1.964v-2.252c0-.564.462-1.025 1.026-1.025h3.497c.564 0 1.026.461 1.026 1.025v2.252c0 .738-.287 1.436-.815 1.959a2.768 2.768 0 0 1-1.96.815Zm-.723-4v1.226c0 .194.077.374.21.513a.74.74 0 0 0 1.02 0 .713.713 0 0 0 .21-.513V56h-1.446.006Z"
    />
    <path
      fill={fillBlack}
      fillRule="evenodd"
      d="M34.166 54.975H30.67v2.25c0 .468.18.909.508 1.237a1.754 1.754 0 0 0 2.477 0c.328-.328.512-.77.512-1.236v-2.251Z"
      clipRule="evenodd"
    />
    <path
      fill={fillBlack}
      d="M32.418 60a2.741 2.741 0 0 1-1.964-.815 2.736 2.736 0 0 1-.81-1.96v-2.25c0-.565.461-1.026 1.025-1.026h3.498c.564 0 1.025.461 1.025 1.025v2.252c0 .738-.287 1.436-.815 1.959a2.79 2.79 0 0 1-1.96.815Zm-.723-4v1.226c0 .194.072.38.205.513a.742.742 0 0 0 1.026 0 .713.713 0 0 0 .21-.513V56H31.69h.005Z"
    />
    <path
      fill={fillGreen}
      d="M43.208 34.36h-3.077a1.029 1.029 0 0 1-1.026-1.026c0-.564.462-1.026 1.026-1.026h3.077c.564 0 1.026.462 1.026 1.026 0 .564-.462 1.025-1.026 1.025ZM1.028 49.61A1.028 1.028 0 0 1 .3 47.856l2.18-2.174c.4-.4 1.05-.4 1.45 0 .4.4.4 1.051 0 1.451l-2.179 2.174c-.2.2-.461.298-.723.298v.005ZM40.13 21.539c-.354 0-.697-.185-.887-.513a1.023 1.023 0 0 1 .374-1.4l2.662-1.539a1.027 1.027 0 0 1 1.4.375 1.023 1.023 0 0 1-.374 1.4L40.643 21.4a1.042 1.042 0 0 1-.513.139Z"
    />
  </svg>
);

Train.propTypes = {
  fillWhite: PropTypes.string,
  fillGreen: PropTypes.string,
  fillBlack: PropTypes.string
};

export default Train;
